import styled from 'styled-components';

import { ConversationFormWrapper } from '@web/conversations/ComposeConversation/composeConversation.styles';

export const CreatePrivateConversationWrapper = styled(ConversationFormWrapper)`
  max-height: calc(100vh - 60px);
`;
